import { paramsToQueryKey } from '@/shared/lib/react-query';

import type { IkpuParams, IkpusParams } from './search.api';

const PREFIX = 'search';

export const SearchQueryKeys = {
  root: [PREFIX],

  getIkpusInfo: (params?: IkpusParams) => paramsToQueryKey([PREFIX, 'ikpus-info'], params),
  getIkpuInfo: (params?: IkpuParams) => paramsToQueryKey([PREFIX, 'ikpu-info'], params),
} as const;
